import { render } from "./KPICard.vue?vue&type=template&id=bec4e514"
import script from "./KPICard.vue?vue&type=script&lang=js"
export * from "./KPICard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__